<template>
  <div class="">
    <ul class="navbar">
      <li>
        <a href="#">{{resume.basics.name}}</a>
      </li>
      <li>
        <a href="#">Skills</a>
      </li>
      <li>
        <a href="#">Experience</a>
      </li>
    </ul>
    <div class="hero">
      <div class="profile">
        <div class="body-background"></div>
        <div class="body-skew"></div>
        <div class="body">
          <img class="photo" src="@/assets/avatar.jpg" alt="">
          <div class="photo-caption">{{resume.basics.name}}</div>
          <div class="photo-sub-caption">{{resume.basics.label}}</div>
          <div class="networks">
            <div :key="profile.network" v-for="profile in resume.basics.profiles" class="network">
              <a :href="profile.url" target="_blank">{{profile.network}}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="hero-brief">
        <div class="body-skew"></div>
        <div class="body">{{resume.basics.summary}}</div>
      </div>
    </div>
    <div class="part-two">
      <div class="skills">
        <div class="wrapper">Skills
          <div v-for="skill in resume.skills" :key="skill.name">
            <div class="skill-name">{{skill.name}}</div>
            <ul class="skill-items">
              <li v-for="keyword in skill.keywords" :key="keyword">{{keyword}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="experience">
        <div class="wrapper">
          <div class="header">Experience</div>
          <ul class="work">
            <li v-for="work in resume.work" :key="work.startDate">
              <div class="card">
                <div class="company">
                  <a v-if="work.website" :href="work.website" target="_blank">{{work.company}}</a>
                  <span v-else>{{work.company}}</span>
                </div>
                <div class="position">{{work.position}}</div>
                <div class="start-date">{{formatDate(work.startDate)}}</div>
                <div class="summary">{{work.summary}}</div>
                <ul class="highlights">
                  <li v-for="highlight in work.highlights" :key="highlight">{{highlight}}</li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["resume"])
  },
  methods: {
    formatDate(dateString) {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      const date = new Date(dateString);
      // const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();
      return `${months[month]} ${year}`;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/style.scss";

$skew-x: skewX(-15deg);
%border-skew {
  height: 100vh;
  transform: $skew-x;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
}
.navbar {
  outline: 1px solid red;
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  left: 0;
  background-color: $white;
  opacity: 0.2;
  @extend %navbar;
  visibility: hidden;
}

.hero {
  height: 100vh;
  .profile,
  .hero-brief {
    position: relative;
    display: inline-block;
    height: 100vh;
    .body {
      z-index: 2;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .profile {
    width: 40%;
    color: $white;
    text-align: center;
    font-size: 0.6rem;
    @media (min-width: $break-small) {
      font-size: 1rem;
    }
    .photo {
      width: 100%;
      border-radius: 50%;
      border: 3px solid #fff;
    }
    .photo-caption {
      margin-top: 0.625rem;
    }
    .photo-sub-caption {
      @extend %secondary-text;
      font-size: 0.6rem;
      margin-bottom: 0.75rem;
      line-height: 1rem;
      @media (min-width: $break-small) {
        font-size: initial;
      }
    }
    .body-background {
      background-color: $black;
      @extend %border-skew;
      transform: translateX(-80%) $skew-x;
    }
    .body-skew {
      background-color: $black;
      @extend %border-skew;
    }
    .body {
      top: 30%;
      @media (min-width: $break-small) {
        top: 50%;
      }

      .networks {
        @extend %secondary-text;

        font-size: 0.6rem;
        @media (min-width: $break-small) {
          font-size: initial;
        }

        .network {
          position: relative;
          display: block;
          @media (min-width: $break-small) {
            margin-right: 0.625rem;
            display: inline-block;
            &:after {
              position: absolute;
              content: "|";
              right: -0.4125rem;
              top: 0;
            }
            &:last-child {
              margin-right: 0;
              &:after {
                display: none;
              }
            }
          }
        }
        a {
          color: $gray;
          transition: all 0.3s;
          &:hover:visited,
          &:hover {
            color: $white;
          }
          &:visited {
            color: $gray;
          }
        }
      }
    }
  }
  .hero-brief {
    width: 60%;
    background-color: $white;
    color: $black;
    font-size: 1rem;
    .body {
      @extend %light-italic;
      top: 60%;
      @media (min-width: $break-small) {
        top: 50%;
      }

      font-size: 0.7rem;
      line-height: 0.8rem;
      width: 50%;

      @media (min-width: $break-tiny) {
        line-height: 1rem;
      }
      @media (min-width: $break-small) {
        line-height: 1.5rem;
        width: 70%;
        font-size: 0.8rem;
      }
      @media (min-width: $break-medium) {
        line-height: 2rem;
        width: 70%;
        font-size: 1rem;
      }
    }
    .body-skew {
      background-color: $white;
      background-color: red;
    }
  }
}
.part-two {
  @extend %clearfix;
  .skills,
  .experience {
    float: none;
    @media (min-width: $break-small) {
      float: left;
    }

    .wrapper {
      padding: 2rem 1.5rem 1rem;
      @media (min-width: $break-small) {
        padding: 3rem 2rem;
      }
    }
  }
  .skills {
    width: 100%;
    @media (min-width: $break-small) {
      width: 32%;
    }
    .skill-name {
      @extend %secondary-text;
    }
    .skill-items {
      list-style-type: none;
      padding: 0;
      margin: 0;
      margin-top: 0.75rem;
      > li {
        @extend %secondary-text;
        cursor: default;
        width: auto;
        display: inline-block;
        margin-bottom: 0.3125rem;
        margin-left: 0.3125rem;
        padding: 0 0.3125rem;
        line-height: 1.5rem;
        @extend %box-shadow;
      }
    }
  }
  .experience {
    width: 100%;
    @media (min-width: $break-small) {
      width: 68%;
      text-align: center;
    }
    .header {
      margin-bottom: 0.75rem;
    }
    .work {
      text-align: left;
      padding: 0;
      list-style-type: none;
      > li {
        .card {
          @extend %box-shadow;
          margin-bottom: 0.75rem;
          padding: 0.75rem 1.5rem 1.5rem;
          border-radius: 2px;
          @extend %secondary-text;
          color: $black;
          .company {
            @extend %light;
            font-size: 1rem;
            display: inline-block;
            a {
              color: $blue;
              border-bottom: 1px solid transparent;
              transition: all 0.3s;
              border-bottom: 1px solid rgba(155, 155, 155, 0.5);
              &:hover {
                border-color: $blue;
              }
              &:visited {
                color: $blue;
              }
            }
          }
          .position {
            @extend %secondary-text;
            display: inline-block;
            margin-left: 0.75rem;
          }
          .summary {
            margin-top: 0.75rem;
          }
          .highlights {
            padding-left: 1.5rem;
            margin-top: 0.75rem;
            list-style-type: disc;
            > li {
              @extend %light;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Resume.vue